import React from 'react';
import { Spinner } from '@signicat/designi/components/loaders';
import "../../styling/components/common/LoadingOverlay.css";

var LoadingOverlay = function LoadingOverlay(props) {
  var background = props.background,
      zIndex = props.zIndex;
  return /*#__PURE__*/React.createElement("div", {
    className: "loading-overlay ".concat(background),
    style: {
      zIndex: zIndex
    }
  }, /*#__PURE__*/React.createElement(Spinner, {
    fullscreen: true
  }));
};

export default LoadingOverlay;